const BackHandler = {};

BackHandler.exitApp = () => {
  return void 0;
};
BackHandler.addEventListener = (eventName, callback) => {
  return void 0;
};

BackHandler.removeEventListener = (eventName, callback) => {
  return void 0;
};

export default BackHandler;
